module.exports = __webpack_public_path__ + "static/media/01B.e94a8dfc.png";